import {domLoaded} from "../base/onLoad";

domLoaded(() => {
    const lazyLoadElements = document.querySelectorAll('[data-src]');
    for(let lazyLoadElement of lazyLoadElements) {
        lazyLoadElement.src = lazyLoadElement.getAttribute('data-src');
    }
});